import { Node, Path } from 'slate';

export const EXERCISE_MULTIPLE_CHOICE = 'exercise-multiple-choice';
export const EXERCISE_MULTIPLE_CHOICE_OPTIONS = 'exercise-multiple-choice-options';
export const EXERCISE_MULTIPLE_CHOICE_OPTION = 'exercise-multiple-choice-option';
export const EXERCISE_MULTIPLE_CHOICE_QUESTIONS = 'exercise-multiple-choice-questions';
export const EXERCISE_MULTIPLE_CHOICE_QUESTION = 'exercise-multiple-choice-question';
export const PARAGRAPH_TOGGLE = 'paragraph-toggle';


export type ExerciseMultipleChoiceOptions = {
  isReadOnly?: boolean;
  onBackWhenInComplete?: () => void;
};

export type ExerciseMultipleChoiceNode = {
  startFrom: number;
  isLoginRequired?: boolean;
} & Node;

export type ExerciseMultipleChoiceEntry = [ExerciseMultipleChoiceNode, Path];

export type ExerciseMultipleChoiceQuestionOptions = {
  isReadOnly?: boolean;
};

export const ExerciseMultipleChoiceQuestionEnum = {
  SINGLE_ANSWER: 'single-answer',
  MULTIPLE_ANSWER: 'multiple-answer',
} as const;

export type ExerciseMultipleChoiceQuestionEnum =
  (typeof ExerciseMultipleChoiceQuestionEnum)[keyof typeof ExerciseMultipleChoiceQuestionEnum];

export type CreteMultipleChoiceQuestionOptions = {
  questionType?: ExerciseMultipleChoiceQuestionEnum;
  question?: string;
  explanation?: string;
  options?: string[];
  correctOptions?: string[];
};

export const MULTIPLE_CHOICE_PARAGRAPH_TOGGLE_TYPES = {
  GUIDE: 'multiple-choice-guide',
  PASSAGE: 'multiple-choice-passage',
  QUESTION: 'multiple-choice-question',
  EXPLANATION: 'multiple-choice-explanation',
};
